import React from 'react';

// Logo component that can be rendered in different sizes
export const TrabadJuLogo = ({ width = 400, height = 400, showSubtext = true, variant = 'square' }) => {
  // Calculate responsive sizes based on container
  const titleSize = variant === 'wide' ? Math.min(width * 0.15, 120) : Math.min(width * 0.18, 100);
  const subtextSize = titleSize * 0.2;
  const gap = titleSize * 0.15;

  return (
    <svg 
      width={width} 
      height={height} 
      viewBox={`0 0 ${width} ${height}`}
      xmlns="http://www.w3.org/2000/svg"
      style={{ background: 'white' }}
    >
      <defs>
        <linearGradient id="logoGradient" x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%" style={{ stopColor: '#3B82F6', stopOpacity: 1 }} />
          <stop offset="50%" style={{ stopColor: '#6366F1', stopOpacity: 1 }} />
          <stop offset="100%" style={{ stopColor: '#9333EA', stopOpacity: 1 }} />
        </linearGradient>
      </defs>
      
      {/* Main Title */}
      <text
        x={width / 2}
        y={showSubtext ? height / 2 - gap : height / 2}
        fontSize={titleSize}
        fontFamily="'Inter', -apple-system, BlinkMacSystemFont, sans-serif"
        fontWeight="700"
        fill="url(#logoGradient)"
        textAnchor="middle"
        dominantBaseline="middle"
      >
        Trabadju
      </text>
      
      {/* Subtitle */}
      {showSubtext && (
        <text
          x={width / 2}
          y={height / 2 + gap + titleSize * 0.3}
          fontSize={subtextSize}
          fontFamily="'Inter', -apple-system, BlinkMacSystemFont, sans-serif"
          fontWeight="500"
          fill="#6B7280"
          textAnchor="middle"
          dominantBaseline="middle"
          letterSpacing="0.15em"
        >
          CABO VERDE
        </text>
      )}
    </svg>
  );
};

// Export component for different social media formats
export const LogoFormats = () => {
  return (
    <div style={{ padding: '20px', background: '#f5f5f5' }}>
      <h1 style={{ marginBottom: '30px' }}>Trabadju - Logos para Redes Sociais</h1>
      
      {/* Instagram Profile - 320x320 */}
      <div style={{ marginBottom: '40px' }}>
        <h3>Instagram Perfil (320x320px)</h3>
        <div id="logo-instagram-profile">
          <TrabadJuLogo width={320} height={320} showSubtext={true} />
        </div>
      </div>

      {/* Instagram Post - 1080x1080 */}
      <div style={{ marginBottom: '40px' }}>
        <h3>Instagram Post (1080x1080px)</h3>
        <div id="logo-instagram-post" style={{ maxWidth: '400px' }}>
          <TrabadJuLogo width={1080} height={1080} showSubtext={true} />
        </div>
      </div>

      {/* Instagram Story - 1080x1920 */}
      <div style={{ marginBottom: '40px' }}>
        <h3>Instagram Story (1080x1920px)</h3>
        <div id="logo-instagram-story" style={{ maxWidth: '300px' }}>
          <TrabadJuLogo width={1080} height={1920} showSubtext={true} variant="vertical" />
        </div>
      </div>

      {/* Facebook Cover - 820x312 */}
      <div style={{ marginBottom: '40px' }}>
        <h3>Facebook Cover (820x312px)</h3>
        <div id="logo-facebook-cover" style={{ maxWidth: '600px' }}>
          <TrabadJuLogo width={820} height={312} showSubtext={true} variant="wide" />
        </div>
      </div>

      {/* Twitter Header - 1500x500 */}
      <div style={{ marginBottom: '40px' }}>
        <h3>Twitter/X Header (1500x500px)</h3>
        <div id="logo-twitter-header" style={{ maxWidth: '600px' }}>
          <TrabadJuLogo width={1500} height={500} showSubtext={true} variant="wide" />
        </div>
      </div>

      {/* Favicon - 512x512 */}
      <div style={{ marginBottom: '40px' }}>
        <h3>Favicon/App Icon (512x512px)</h3>
        <div id="logo-favicon">
          <TrabadJuLogo width={512} height={512} showSubtext={false} />
        </div>
      </div>

      <div style={{ marginTop: '40px', padding: '20px', background: 'white', borderRadius: '8px' }}>
        <h3>📥 Como Exportar para PNG:</h3>
        <ol>
          <li>Clica com botão direito em cada logo acima</li>
          <li>Seleciona "Guardar imagem como..." ou "Save image as..."</li>
          <li>Escolhe formato PNG</li>
          <li>Ou usa a ferramenta de screenshot do navegador para capturar cada seção</li>
        </ol>
      </div>
    </div>
  );
};

export default LogoFormats;
